export const commonKanagawaEnvironment = {
  serverName: 'civix',
  surveillanceUrl: 'https://surveillance.interactivelife.me/',
  isContainer: false,
  aliveAppIntervalMinutes: 30, // if you keep app inactive
  subServerName: '',
  lnglatdefault: {
    lat: 36.2048,
    lng: 138.2529
  },
  lang: 'ja',
  productId: '40095093-5ee8-44eb-b92a-68cb5ae9d04c',
  projectName: 'cipher',
  group: 'web-2.0',
  profileImageURL: '',
  orgType: 'cipher',
  orgId: '65afbb77ecac8e05c82aff5d',
  appId: '65afbbc4ecac8e05c82aff63',
  locId: '65afbbfbecac8e05c82aff67',
  customKeys: {
    roleAdmin: '5eb137f1d3123a407c7c97cc',
    roleInvestigators: '64dc639a4096f85368c00770',
    rolePrefectureCommanders: '64dc69d44096f85368c00776',
    roleRegionCommanders: '65b0a7ddecac505ef2f994d8',
    roleTechnicians: '65b0a7faecac505ef2f994da',
    roleDevice: '69ddfee6efa95111c661c3d1',
  },
  customKeysView: {
    '5eb137f1d3123a407c7c97cc': 'Admin',
    '64dc639a4096f85368c00770': 'Investigators',
    '64dc69d44096f85368c00776': 'Prefecture Commanders',
    '65b0a7ddecac505ef2f994d8': 'Region Commanders',
    '65b0a7faecac505ef2f994da': 'Technicians',
  },
  rollbar: {
    apiKey: '9c5ba84789c04a4db6bd4343ee519c4c'
  },
  rolesCanAccess: ['5eb137f1d3123a407c7c97cc', '64dc69d44096f85368c00776', '65b0a7ddecac505ef2f994d8', '64dc639a4096f85368c00770'],
  googleMapsApiKey: 'AIzaSyBr2aRdRjabAfk-WQvyhrF0CUVl3y0khuE',
  mapTilerApiKey: 'X3UTImSh1Tz8jv3byHTv',
  sentryDsn: 'https://55fdb531dc1b79b523b0641e641b39ea@o4510715001634816.ingest.us.sentry.io/4510736298737664',
  translationTemplate: 'default',
};
